import React from 'react'
// https://oblador.github.io/react-native-vector-icons/
import AntDesign from 'react-native-vector-icons/AntDesign';
type Props = {
  name: string,
  size?: number,
  color?: string
}
const Icon = ({ name, size, color }: Props) => {
  return (
    <AntDesign name={name} size={size || 20} color={color || '#333'}></AntDesign>
  )
}

export default Icon